/* __next_internal_client_entry_do_not_use__ SDUIUPLTWrapper auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { TelemetryManager } from "@faire/web--source/common/opentelemetry/TelemetryManager";
import { useUserPerceivedLoadTimingWithKey } from "@faire/web--source/common/performance/userPerceivedLoadTiming/useUserPerceivedLoadTiming";
import { useWaitForImagesToLoad } from "@faire/web--source/common/performance/useWaitForImagesToLoad/useWaitForImagesToLoad";
import { generateTracingMetadata } from "@faire/web--source/common/tracing/generateTracingMetadata";
import { useMergedRefs } from "@faire/web--source/ui/hooks/useMergedRefs";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import * as React from "react";
import { useNumComponentsByClientSize } from "@faire/retailer/components/SDUI/UPLT/useNumComponentsByClientSize";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { SDUIUPLTContext } from "./SDUIUPLTContext";
var IMAGE_PERCENTAGE_REMAINING = 0.1;
var IMAGE_COUNT_REMAINING = 1;
var IMAGE_LOADING_TIMEOUT = 7000;
export var SDUIUPLTWrapper = function(_param) {
    var children = _param.children, numComponentsPerClientSize = _param.numComponentsPerClientSize, shouldUseWaitForImagesToLoadPromise = _param.shouldUseWaitForImagesToLoadPromise, onImageLoad = _param.onImageLoad, rest = _object_without_properties(_param, [
        "children",
        "numComponentsPerClientSize",
        "shouldUseWaitForImagesToLoadPromise",
        "onImageLoad"
    ]);
    var renderNonPrimaryContentResolveRef = React.useRef(function() {});
    var _React_useState = _sliced_to_array(React.useState(function() {
        return new Promise(function(resolve) {
            renderNonPrimaryContentResolveRef.current = resolve;
        });
    }), 1), renderNonPrimaryContentPromise = _React_useState[0];
    var numComponents = useNumComponentsByClientSize(numComponentsPerClientSize);
    var userToken = useUserStore([
        "userToken"
    ]).userToken;
    var _useViewport = useViewport(), isDesktopAndAbove = _useViewport.isDesktopAndAbove, isMobile = _useViewport.isMobile;
    var loadTimingRef = useUserPerceivedLoadTimingWithKey(_object_spread_props(_object_spread({}, rest), {
        numComponents: numComponents,
        trackResultCallback: function(name, status, loadType, result) {
            var metadata = generateTracingMetadata({
                name: name,
                loadType: loadType,
                status: status,
                result: result,
                userToken: userToken,
                isDesktopAndAbove: isDesktopAndAbove,
                isMobile: isMobile
            });
            TelemetryManager.get().endTrace("uplt-".concat(name), metadata);
        }
    }));
    var handleRenderNonPrimaryContent = function() {
        renderNonPrimaryContentResolveRef.current();
    };
    var waitForImagesToLoadRef = useWaitForImagesToLoad({
        numComponents: numComponents !== null && numComponents !== void 0 ? numComponents : Infinity,
        onImageLoad: function(numImagesPending, totalNumImages) {
            if (numImagesPending < IMAGE_COUNT_REMAINING || numImagesPending / totalNumImages < IMAGE_PERCENTAGE_REMAINING) {
                handleRenderNonPrimaryContent();
                onImageLoad === null || onImageLoad === void 0 ? void 0 : onImageLoad();
            }
        },
        onTimeout: handleRenderNonPrimaryContent,
        timeout: IMAGE_LOADING_TIMEOUT
    });
    var ref = useMergedRefs(loadTimingRef, shouldUseWaitForImagesToLoadPromise ? waitForImagesToLoadRef : undefined);
    return /*#__PURE__*/ _jsx(SDUIUPLTContext.Provider, {
        value: {
            refCallback: ref,
            numComponents: numComponents,
            renderNonPrimaryContentPromise: renderNonPrimaryContentPromise
        },
        children: children
    });
};
